// EmailJS Configuration
// You'll need to set up EmailJS account and get these credentials
// Visit: https://www.emailjs.com/

export const EMAIL_CONFIG = {
  // EmailJS service ID from environment variables
  SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID,
  
  // EmailJS template ID from environment variables
  TEMPLATE_ID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
  
  // EmailJS public key from environment variables
  PUBLIC_KEY: process.env.REACT_APP_EMAILJS_PUBLIC_KEY
};

// Email templates
export const EMAIL_TEMPLATES = {
  PASSWORD_RESET: {
    subject: 'Password Reset OTP - Student Fee Management System',
    template: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
        <div style="background-color: #007bff; color: white; padding: 20px; text-align: center;">
          <h2>Student Fee Management System</h2>
        </div>
        
        <div style="padding: 30px; background-color: #f8f9fa;">
          <h3 style="color: #333;">Password Reset Request</h3>
          
          <p>Hello,</p>
          
          <p>You have requested to reset your password for the Student Fee Management System admin account.</p>
          
          <div style="background-color: #e9ecef; padding: 20px; border-radius: 5px; text-align: center; margin: 20px 0;">
            <h2 style="color: #007bff; margin: 0;">Your OTP is: {{otp}}</h2>
          </div>
          
          <p><strong>Instructions:</strong></p>
          <ol>
            <li>Go to the admin login page</li>
            <li>Click "Forgot Password?"</li>
            <li>Enter this OTP: <strong>{{otp}}</strong></li>
            <li>Set your new password</li>
          </ol>
          
          <p><strong>Important:</strong></p>
          <ul>
            <li>This OTP is valid for 10 minutes</li>
            <li>Do not share this OTP with anyone</li>
            <li>If you didn't request this reset, please ignore this email</li>
          </ul>
          
          <p>Best regards,<br>
          Student Fee Management System</p>
        </div>
        
        <div style="background-color: #6c757d; color: white; padding: 15px; text-align: center; font-size: 12px;">
          <p>This is an automated message. Please do not reply to this email.</p>
        </div>
      </div>
    `
  }
};

// Generate random OTP
export const generateOTP = () => {
  return Math.floor(100000 + Math.random() * 900000).toString();
};
